
import Hero from "../components/Hero";
import Services from "../components/Services";
import PricingSection from "../components/PricingSection";
import ContactSection from "../components/ContactSection";

const Home = () => {

  return (
    <div className="font-sans overflow-x-hidden">

      <Hero/>
      <Services/>
      <PricingSection /> 
      <ContactSection />  
      
    </div>
  );
};

export default Home;
